const LocationIcon = () => {
    return (
        <svg viewBox="0 0 100 100">
            <path
                d="M50,99c27,0,49-22,49-49S77,1,50,1S1,23,1,50S23,99,50,99 M50,7.1c23.6,0,42.9,19.2,42.9,42.9S73.6,92.9,50,92.9
S7.1,73.6,7.1,50S26.4,7.1,50,7.1"
            />
            <path
                d="M29.3,74.6l32.5-10.8c0.9-0.3,1.6-1,1.9-1.9l10.8-32.5c0.4-1.1,0.1-2.3-0.7-3.1c-0.8-0.8-2-1.1-3.1-0.7L38.2,36.3
c-0.9,0.3-1.6,1-1.9,1.9L25.4,70.7c-0.4,1.1-0.1,2.3,0.7,3.1C27,74.7,28.2,74.9,29.3,74.6 M41.6,41.6l25.2-8.4l-8.4,25.2l-25.2,8.4
L41.6,41.6z"
            />
            <path d="M47.8,47.8c-1.2,1.2-1.2,3.2,0,4.3c1.3,1.2,3.1,1.2,4.3,0c1.2-1.1,1.2-3,0-4.3C51,46.7,49,46.7,47.8,47.8" />
        </svg>
    );
};

export default LocationIcon;
